import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tellimuse kokkuvõte

  <span style="color:#85c1dc;">**FI:**</span>
  Tilauksen yhteenveto

  <span style="color:#85c1dc;">**RU:**</span>
  Итог заказа
*/
/* @__NO_SIDE_EFFECTS__ */
const m938 = msg(
  mf`Tellimuse kokkuvõte`,
  mf`Tilauksen yhteenveto`,
  mf`Итог заказа`,
)

export { m938 as 'w.basket.summary' }